import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {Configuracion} from "../configuracion/configuracion";
import {UrlService} from "./url.service";


@Injectable()
export class ConfiguracionService {

    private headers = new Headers({'Content-Type': 'application/json'});//parametrizamos a json
    private options = new RequestOptions({headers: this.headers});
    private url = this.URL.getLocal()+'/configuracion';//Url que maneja GET ,POST
    private urlById = this.URL.getLocal()+'/configuracion/';//Url que maneja GET ,POST
    private urlDelete = 'http://url/';//Url que maneja GET ,POST
    private urlPut = this.URL.getLocal()+'/configuracion/';//Url que maneja GET ,POST


    constructor(private URL:UrlService,private http: Http) {
    }


  getConfiguracion(): Observable<Configuracion[]> {
        let url = `${this.url}`;
        return this.http.get(url, this.options)
            .map(r => r.json())
        //.catch(this.handleError)
    }


    getConfiguracionById(id: number): Observable<Configuracion[]> {
        let url = `${this.urlById}${id}`;
        return this.http.get(url, this.options)
            .first()
            .map(r => r.json())
        //.catch(this.handleError)
    }

  addConfiguracion(item: Configuracion) {
        let url = `${this.url}`;
        let iJson = JSON.stringify(item);
        return this.http.post(url, iJson, this.options)
            .map(r => r.json())
        //.catch(this.handleError);

    }

    delete(id: number) {
        let url = `${this.urlDelete}id`;
        return this.http.get(url, this.options)
            .map(r => r.json())
        //.catch(this.handleError);
    }

  putConfiguracion(item: Configuracion, id: number) {
        let url = `${this.urlPut}${id}`;
        let iJson = JSON.stringify(item);
        return this.http.put(url, iJson, this.options)
            .map(r => r.json())
        //.catch(this.handleError);
    }

//Error Handler

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/configuracion.service.ts